import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import { toast } from "react-toastify";
import EditDocType from "./EditDocTypes";
import { addDocType } from "services/docTypeService";
import DocTypeList from "./DocTypesList";

const DocTypes = () => {
  const [addNewForm, setAddNewForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    const result = await addDocType({
      active: true,
      ...data,
    });
    setIsSubmitting(false);

    if (result.success) {
      toast.success("Document Type Added");
      setAddNewForm(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn setting-btn`}
          onClick={() => {
            setAddNewForm(true);
          }}
        >
          Add Document<br />
          Type
        </Button>
      </div>
      <div className="flex-grow-1 mb-2" style={{ minHeight: 0 }}>
        <DocTypeList />
      </div>
      {addNewForm && (
        <EditDocType
          type="addNew"
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
          cancelEdit={() => setAddNewForm(false)}
        />
      )}
    </div>
  );
};

export default DocTypes;
